import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ScheduleComment, ScoutTask } from '../../../core/models';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LookupService, BuildingDoc, BuildingService, PointService, UserService, ScoutTaskService } from '../../../core/services';
import { ScoutTaskDoc } from '../../../core/schema/scout-task-schema';
import { UserDoc } from '../../../core/schema/user-schema';
import { FesBaseComponent } from '../../../shared/components/fes-base.component';
import { AppState } from '../../../core';

@Component({
  selector: 'app-scout-edit',
  templateUrl: './scout-edit.component.html',
  styleUrls: ['./scout-edit.component.scss']
})
export class ScoutEditComponent extends FesBaseComponent implements OnInit, OnDestroy {


  //Need to add stage and building

  onYes = () => {}

  @Input() set scout(scout: any) {
    this.tmpScout = new ScoutTask()
    this.tmpScout.assignments = {
      scheduleUserId: "",
      testUserId: ""
    }
    this.tmpScout.status = {
      scheduleRequested: {
        timestamp: "",
        userId: null
      }
    }
    this.tmpScout.schedule = {
      scheduleNotes: "",
      scheduledDate: "",
      scheduleComments: []
    }
    this.tmpScout.stage = scout.stage
    this.tmpScout.buildingId = scout.id
  }
  tmpScout: ScoutTask

  stages: any[]
  buildings: BuildingDoc[] = []
  schedulerUsers: UserDoc[] = []
  selectedUser: UserDoc

  public errorMsg: string = ''
  isLoading: boolean = false;
  bProcessing: boolean = false;

  constructor(
    appState: AppState,
    protected editModal: BsModalRef,
    private buildingService: BuildingService,
    private lookupService: LookupService,
    private pointService: PointService,
    private userService: UserService,
    private scoutService: ScoutTaskService
  ) {
    super(appState)
  }

  ngOnInit(): void {
    this.onBuildingChange()
  }

  ngOnDestroy(): void {
    this.destroy()
  }

  async onSave() {
    this.errorMsg = ''
    this.bProcessing = true;
    try {
      await this.scoutService.create(this.tmpScout)
      this.editModal.hide()
    } catch (error) {
      this.errorMsg = this.scoutService.extractErrorMsg(error)
      this.scoutService.publishError(error, this)
    } finally {
      // this.scoutService.sync()
      this.bProcessing = false
    }
  }

  onCancel() {
    this.editModal.hide()
  }

  onStageChange(stage: string) {
    const buildingQuery = this.buildingService.rxCollection.find()
    this.subscribe(
      buildingQuery.$,
      async buildings => {
        await this.updateBuildingList(buildings, stage)
      },
      error => {
        this.buildingService.publishError(error, this)
      }
    )
  }

  async updateBuildingList(buildings: BuildingDoc[], stage: string) {
    this.isLoading = true;
    let stageName = ""
    this.stages.forEach(stageItem => {
      if (stage == stageItem.id) {
        stageName = stageItem.name
      }
    });

    try {
      const stageBuildings = []
      for (let i = 0; i < buildings.length; i++) {
        const building = buildings[i]
        let isStageBuilding = await this.pointService.isStage(building.id, stageName)
        if (isStageBuilding) {
          stageBuildings.push(building)
        }
      }
      this.buildings = stageBuildings
    } catch (error) {
      this.buildingService.publishError(error, this)
    } finally {
      this.isLoading = false;
      this.bProcessing = false;
    }
  }

  async onBuildingChange() {
    this.isLoading = true;
    try {
      this.schedulerUsers = await this.userService.rxCollection.find().sort({ 'firstName': 'asc', 'lastName': 'asc' }).where({ "role": "scheduler" }).exec()
    } catch (error) {
      this.userService.publishError(error, this)
      return
    } finally {
      this.isLoading = false
    }
  }
}
